import { createSignal, Show, For, } from "solid-js";
import { Row, Col } from "solid-bootstrap";
import { ThemeForm } from "./themeform";
import { Service } from "../../../service/theme/theme";
import { FormWidget } from "../../theme/formwidget";
import { PictureManager } from "../../picturemanager/picturemanager";

function toPixelString(value) {
    const intVal = parseInt(value);
    if (isNaN(intVal)) {
        return "1px";
    }

    return intVal + "px";
}

function toPointString(value) {
    const intVal = parseInt(value);
    if (isNaN(intVal)) {
        return "1pt";
    }

    return intVal + "pt";
}

export function ThemeStage(props) {
    const [myTheme, setMyTheme] = createSignal(props.theme);
    const readFormFields = (formTheme) => {
        const skinSections = Service.getSkinFormSections(myTheme().skin_name);
        skinSections.sections.forEach(section => {
            section.fields.forEach(field => {
                const fieldId = `theme.${field.name}`;
                const formField = document.getElementById(fieldId);
                if (!formField) {
                    console.log(`field ${fieldId} not found`);
                    return;
                }
                switch (field.kind) {
                    case "pixel":
                        formTheme[field.name] = toPixelString(formField.value);
                        break;
                    case "point":
                        formTheme[field.name] = toPointString(formField.value);
                        break;
                    case "color":
                        formTheme[field.name] = formField.value;
                        break;
                    case "select":
                        const selectedOption = formField.options[formField.selectedIndex];
                        formTheme[field.name] = selectedOption.value;
                        break;
                    case "number":
                        formTheme[field.name] = parseInt(formField.value);
                        break;
                    default:
                        console.error(`Unknown field kind: ${field.kind}`);
                }
            })
        });

        formTheme["is_user_set_theme"] = true;

        return formTheme;
    };

    // The field must be a non-negative integer, otherwise set invalid and return false.
    function validateNonNegativeIntegerField(fieldId) {
        const field = document.getElementById(fieldId);
        if (!field) {
            console.error(`field ${fieldId} not found`);
            return false;
        }

        const value = parseInt(field.value);
        if (isNaN(value) || value < 0) {
            field.setCustomValidity("Value must be a non-negative integer");
            field.reportValidity();
            return false;
        }

        return true;
    }

    function validate() {
        const numFields = [];
        const skinSections = Service.getSkinFormSections(myTheme().skin_name);
        skinSections.sections.forEach(section => {
            section.fields.forEach(field => {
                const fieldId = `theme.${field.name}`;
                if (field.kind === "number" || field.kind === "pixel" || field.kind === "point") {
                    numFields.push(fieldId);
                }
            });
        });

        let isValid = true;
        for (const fieldId of numFields) {
            if (!validateNonNegativeIntegerField(fieldId)) {
                isValid = false;
            }
        }

        return isValid;
    }

    return <>
        <ThemeForm title="Customise theme" validate={validate} theme={props.theme} setTheme={setMyTheme} readFormFields={readFormFields} submitText="Save theme">

            <h1>Select background image</h1>
            <PictureManager theme={myTheme()} />

            <For each={Service.getSkinFormSections(myTheme().skin_name).sections}>
                {(section) => <>
                    <h2>{section.label}</h2>
                    <For each={section.fields}>
                        {(field) =>
                            <>
                                <Show when={field.kind !== "color"}>
                                    <Row>
                                        <Col xs={12} md={3}>
                                            <FormWidget {...field} themeSignal={myTheme} />
                                        </Col>
                                    </Row>
                                </Show>
                                <Show when={field.kind === "color"}>
                                    <FormWidget {...field} themeSignal={myTheme} valueFunc={(theme) => theme[field.name]} />
                                </Show>
                            </>
                        }
                    </For>
                    <Show when={section.label === "Font selection"}>
                        <h3>Font copyright notice</h3>

                        <Row>
                            <Col xs={12} md={6}>
                                <p>Fonts are copyright their owners and we only use fonts we understand are valid for our use in this project.
                                    All fonts are credited to their authors in the labels above.
                                    If any font authors or copyright holders have any issues please get in touch with <a href="mailto:john.morrice.developer@gmail.com">support</a>.</p>
                            </Col>
                        </Row>
                    </Show>
                </>}
            </For>



        </ThemeForm>

    </>;

}